import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import PageSEO from '@/components/base/PageSEO';
import HeroSection from './components/HeroSection';
import ServiceSection from './components/ServiceSection';
import StatsSection from './components/StatsSection';
import ArticleSection from './components/ArticleSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <PageSEO
        title="木瓜玩官网 - 海外游戏发行与用户增长平台 | 游戏出海一站式营销"
        description="木瓜玩官网是专注海外游戏发行、买量投放与用户增长的一站式营销平台。提供精准广告投放、数据分析、创意素材制作等全链路服务，助力游戏出海企业快速拓展全球市场，实现高效获客与ROI最大化。"
        keywords="木瓜玩官网,木瓜玩平台注册,木瓜玩游戏出海,木瓜玩买量投放,木瓜玩广告服务,海外游戏发行平台,游戏出海用户增长"
        canonicalUrl="https://steamvip520.cn/"
        schemaJson={{
          "@context": "https://schema.org",
          "@type": "WebSite",
          "name": "木瓜玩",
          "url": "https://steamvip520.cn/",
          "description": "专注海外游戏发行、买量投放与用户增长的一站式营销平台",
          "potentialAction": {
            "@type": "SearchAction",
            "target": "https://steamvip520.cn/articles?search={search_term_string}",
            "query-input": "required name=search_term_string"
          }
        }}
      />
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <ServiceSection />
        <StatsSection />
        <ArticleSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}